export const PrivacyPolicy = () => {
  return (
    <div className='max-w-4xl mx-auto min-h-[60vh] py-4 text-indigo px-8'>
      <h3 className='text-center font-semibold text-2xl py-4'>
        AWAP INVESTORS LTD &ndash; Privacy Policy
      </h3>

      <p className='font-light mb-4 text-center'>
        <strong>Effective Date:</strong> 1st May, 2024
      </p>

      {/* 1 */}
      <h4 className='font-medium py-4'>1. Introduction</h4>
      <p className='font-light mb-4'>
        AWAP INVESTORS LTD (&ldquo;AWAP&rdquo;, &ldquo;we&rdquo;,
        &ldquo;our&rdquo;, or &ldquo;us&rdquo;) is committed to protecting the
        privacy, confidentiality, and security of your personal information.
      </p>
      <p className='font-light mb-4'>
        This Privacy Policy explains how we collect, use, store, disclose, and
        protect your personal information when you access or use the AWAP
        INVESTORS LTD Platform, including our website, mobile application, and
        related services.
      </p>
      <p className='font-light mb-4'>
        Our Platform enables users to participate in Project Slots (APS), own
        and trade AWAP Project Units (APU), buy and sell eligible real estate,
        acquire land through Land Pay, save money, apply for loans, trade
        supported cryptocurrencies, participate in the Builders Reward System
        (BRS), and use other financial services provided by the company.
      </p>
      <p className='font-light mb-4'>
        By using our Platform, you consent to the collection and processing of
        your personal information as described in this Privacy Policy.
      </p>

      {/* 2 */}
      <h4 className='font-medium py-4'>2. Information We Collect</h4>
      <p className='font-light mb-4'>
        Depending on the services you use, we may collect the following
        information:
      </p>

      <p className='font-light mb-2'>
        <strong>2.1 Personal Information</strong>
      </p>
      <ul className='list-disc list-inside font-light mb-4 space-y-1 pl-4'>
        <li>Full name</li>
        <li>Date of birth</li>
        <li>Gender</li>
        <li>Nationality</li>
        <li>Residential address</li>
        <li>Email address</li>
        <li>Phone number</li>
      </ul>

      <p className='font-light mb-2'>
        <strong>2.2 Identity Verification (KYC)</strong>
      </p>
      <p className='font-light mb-2'>
        To comply with regulatory requirements, we may collect:
      </p>
      <ul className='list-disc list-inside font-light mb-4 space-y-1 pl-4'>
        <li>National Identification Number (NIN)</li>
        <li>International Passport</li>
        <li>Driver&apos;s License</li>
        <li>National Identity Card</li>
        <li>Voter&apos;s Card</li>
        <li>Selfie or facial verification</li>
        <li>Utility bills or proof of address where required</li>
      </ul>

      <p className='font-light mb-2'>
        <strong>2.3 Financial Information</strong>
      </p>
      <p className='font-light mb-2'>We may collect:</p>
      <ul className='list-disc list-inside font-light mb-4 space-y-1 pl-4'>
        <li>Bank account details</li>
        <li>Bank Verification Number (BVN), where required</li>
        <li>Payment records</li>
        <li>Wallet balances</li>
        <li>Loan information</li>
        <li>Savings information</li>
        <li>Crypto transaction records</li>
      </ul>

      <p className='font-light mb-2'>
        <strong>2.4 Transaction Information</strong>
      </p>
      <p className='font-light mb-2'>This includes records relating to:</p>
      <ul className='list-disc list-inside font-light mb-4 space-y-1 pl-4'>
        <li>Project Slot (APS) participation</li>
        <li>AWAP Project Unit (APU) purchases and transfers</li>
        <li>Real Estate Market transactions</li>
        <li>Land Pay installment payments</li>
        <li>Savings activities</li>
        <li>Loan applications and repayments</li>
        <li>Builders Reward System earnings</li>
        <li>Wallet deposits and withdrawals</li>
        <li>Cryptocurrency purchases and sales</li>
      </ul>

      <p className='font-light mb-2'>
        <strong>2.5 Technical Information</strong>
      </p>
      <p className='font-light mb-2'>We may automatically collect:</p>
      <ul className='list-disc list-inside font-light mb-4 space-y-1 pl-4'>
        <li>IP address</li>
        <li>Browser type</li>
        <li>Device information</li>
        <li>Operating system</li>
        <li>Device ID</li>
        <li>Cookies</li>
        <li>Login records</li>
        <li>Usage statistics</li>
        <li>Location information where permitted</li>
      </ul>

      <p className='font-light mb-2'>
        <strong>2.6 Communication Information</strong>
      </p>
      <p className='font-light mb-2'>Including:</p>
      <ul className='list-disc list-inside font-light mb-4 space-y-1 pl-4'>
        <li>Emails</li>
        <li>Customer support requests</li>
        <li>Chat messages</li>
        <li>Phone conversations</li>
        <li>Feedback and surveys</li>
      </ul>

      {/* 3 */}
      <h4 className='font-medium py-4'>3. How We Use Your Information</h4>
      <p className='font-light mb-2'>We use your information to:</p>
      <ul className='list-disc list-inside font-light mb-4 space-y-1 pl-4'>
        <li>Create and manage your account.</li>
        <li>Verify your identity.</li>
        <li>Process Project Slot participation.</li>
        <li>Manage AWAP Project Units (APU).</li>
        <li>Process Real Estate Market and Land Pay transactions.</li>
        <li>Administer savings and loan services.</li>
        <li>Process cryptocurrency transactions.</li>
        <li>Operate the Builders Reward System.</li>
        <li>Process deposits and withdrawals.</li>
        <li>
          Detect and prevent fraud, money laundering, identity theft, and other
          illegal activities.
        </li>
        <li>Improve our products and services.</li>
        <li>Respond to customer support requests.</li>
        <li>Send important service notifications.</li>
        <li>Send promotional messages where permitted.</li>
        <li>Comply with legal and regulatory obligations.</li>
        <li>Enforce our Terms and Conditions and other company policies.</li>
      </ul>

      {/* 4 */}
      <h4 className='font-medium py-4'>4. Cookies and Tracking Technologies</h4>
      <p className='font-light mb-2'>
        We use cookies and similar technologies to:
      </p>
      <ul className='list-disc list-inside font-light mb-4 space-y-1 pl-4'>
        <li>Remember user preferences.</li>
        <li>Maintain secure login sessions.</li>
        <li>Improve website performance.</li>
        <li>Analyze Platform usage.</li>
        <li>Enhance user experience.</li>
      </ul>
      <p className='font-light mb-4'>
        Users may disable cookies through their browser settings, although
        certain Platform features may become unavailable.
      </p>

      {/* 5 */}
      <h4 className='font-medium py-4'>5. How We Share Your Information</h4>
      <p className='font-light mb-2'>We may disclose your information to:</p>
      <ul className='list-disc list-inside font-light mb-4 space-y-1 pl-4'>
        <li>Payment service providers.</li>
        <li>Banking partners.</li>
        <li>Identity verification providers.</li>
        <li>Technology service providers.</li>
        <li>Professional advisers and auditors.</li>
        <li>Regulatory authorities.</li>
        <li>Law enforcement agencies where legally required.</li>
        <li>Courts or government agencies pursuant to lawful requests.</li>
        <li>Business partners involved in providing Platform services.</li>
        <li>
          Successors or acquiring entities in the event of a merger,
          acquisition, restructuring, or sale of company assets.
        </li>
      </ul>
      <p className='font-light mb-4'>
        We do not sell your personal information to third parties.
      </p>

      {/* 6 */}
      <h4 className='font-medium py-4'>6. Data Security</h4>
      <p className='font-light mb-4'>
        We implement reasonable administrative, technical, and physical
        safeguards to protect your personal information.
      </p>
      <p className='font-light mb-2'>These measures include:</p>
      <ul className='list-disc list-inside font-light mb-4 space-y-1 pl-4'>
        <li>Data encryption.</li>
        <li>Secure servers.</li>
        <li>Firewalls.</li>
        <li>Multi-layer access controls.</li>
        <li>Security monitoring.</li>
        <li>Regular software updates.</li>
        <li>Employee confidentiality obligations.</li>
      </ul>
      <p className='font-light mb-4'>
        Although we strive to protect your information, no internet transmission
        or electronic storage system can be guaranteed to be completely secure.
      </p>

      {/* 7 */}
      <h4 className='font-medium py-4'>7. Data Retention</h4>
      <p className='font-light mb-2'>
        We retain personal information only for as long as necessary to:
      </p>
      <ul className='list-disc list-inside font-light mb-4 space-y-1 pl-4'>
        <li>Provide our services.</li>
        <li>Comply with applicable laws.</li>
        <li>Resolve disputes.</li>
        <li>Prevent fraud.</li>
        <li>Enforce our legal agreements.</li>
      </ul>
      <p className='font-light mb-4'>
        Transaction records and financial information may be retained for a
        minimum of five (5) years or for any longer period required under
        applicable law.
      </p>

      {/* 8 */}
      <h4 className='font-medium py-4'>8. Your Rights</h4>
      <p className='font-light mb-2'>Subject to applicable law, you may:</p>
      <ul className='list-disc list-inside font-light mb-4 space-y-1 pl-4'>
        <li>Access your personal information.</li>
        <li>Correct inaccurate information.</li>
        <li>Request deletion of eligible personal information.</li>
        <li>Object to certain processing activities.</li>
        <li>Request restriction of processing.</li>
        <li>
          Request a copy of your personal information in a portable format.
        </li>
        <li>Withdraw consent where processing is based on consent.</li>
        <li>Lodge complaints with the appropriate regulatory authority.</li>
      </ul>
      <p className='font-light mb-4'>
        Certain requests may be limited where retention is required by law or
        for legitimate business purposes.
      </p>

      {/* 9 */}
      <h4 className='font-medium py-4'>9. Children&apos;s Privacy</h4>
      <p className='font-light mb-4'>
        Our Platform is intended only for individuals who are legally eligible
        to enter into binding agreements under applicable law.
      </p>
      <p className='font-light mb-4'>
        We do not knowingly collect personal information from children without
        appropriate legal authorization.
      </p>

      {/* 10 */}
      <h4 className='font-medium py-4'>10. International Data Transfers</h4>
      <p className='font-light mb-4'>
        Where necessary, your personal information may be processed or stored by
        trusted service providers located in other jurisdictions.
      </p>
      <p className='font-light mb-4'>
        We take appropriate measures to ensure that such transfers comply with
        applicable data protection laws.
      </p>

      {/* 11 */}
      <h4 className='font-medium py-4'>11. Third-Party Services</h4>
      <p className='font-light mb-4'>
        Our Platform may contain links to third-party websites or services.
      </p>
      <p className='font-light mb-4'>
        We are not responsible for the privacy practices, policies, or content
        of third-party websites or services.
      </p>
      <p className='font-light mb-4'>
        Users are encouraged to review the privacy policies of any third-party
        platforms they access.
      </p>

      {/* 12 */}
      <h4 className='font-medium py-4'>12. Changes to this Privacy Policy</h4>
      <p className='font-light mb-4'>
        We may update this Privacy Policy from time to time.
      </p>
      <p className='font-light mb-4'>
        Where required, we will notify users of material changes through the
        Platform, email, or other appropriate communication channels.
      </p>
      <p className='font-light mb-4'>
        Continued use of the Platform after the effective date of any revised
        Privacy Policy constitutes acceptance of the updated Policy.
      </p>

      {/* 13 */}
      <h4 className='font-medium py-4'>13. Contact Us</h4>
      <p className='font-light mb-4'>
        For questions regarding this Privacy Policy or our data protection
        practices, please contact:
      </p>
      <p className='font-light mb-2'>
        <strong>AWAP INVESTORS LTD</strong>
      </p>
      <p className='font-light mb-2'>
        Email:{' '}
        <a
          href='mailto:info@awapinvestors.com'
          className='text-blue-600 hover:underline'
        >
          info@awapinvestors.com
        </a>
      </p>
      <p className='font-light mb-4'>Website: www.awapinvestors.com</p>

      <p className='font-light mb-4 italic'>
        By using the AWAP INVESTORS LTD Platform, you acknowledge that you have
        read, understood, and agreed to this Privacy Policy.
      </p>
    </div>
  );
};
